if (!customElements.get('fe-sony-offers')) {
  customElements.define('fe-sony-offers', class extends HTMLElement {
    static offerState(data, price, now) {
      const active = (start, end) => now >= Number(start) && now < Number(end);
      const standard = active(data.normalStart, data.normalEnd) ? Number(data.standard) : 0;
      const student = active(data.studentStart, data.studentEnd) ? Number(data.student) : 0;
      const finance = data.finance === 'true' && active(data.financeStart, data.financeEnd) && price > 0 && price <= 1000000;
      const premium = data.premium === 'true' && active(data.premiumStart, data.premiumEnd) && price >= 500000 && price <= 1000000;
      return {standard,student,finance,premium,rates:finance && price >= 150000};
    }
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.variants = JSON.parse(this.querySelector('[data-fe-so-variants]').textContent);
      this.scope = this.closest('.product-main') || this.closest('[data-section-id]') || document;
      this.formatter = new Intl.NumberFormat(document.documentElement.lang || 'it-IT', {style: 'currency', currency: 'EUR'});
      this.mode = 'standard';
            this.onChange = () => requestAnimationFrame(() => this.update());
      this.onVariant = event => this.update(event.detail?.variant?.id);
      this.onPageShow = () => this.reset();
      this.onVisibility = () => { if (!document.hidden) this.update(); };
      this.mobileToggle = this.querySelector('[data-fe-so-toggle]');
      this.onMobileToggle = () => {
        const expanded = this.classList.toggle('fe-so--expanded');
        this.mobileToggle?.setAttribute('aria-expanded', String(expanded));
      };
      this.mobileToggle?.addEventListener('click', this.onMobileToggle);
      this.onChoice = event => {
        if (event.target.matches('input[type="radio"]')) {
          this.mode = event.target.value;
          this.update();
        }
      };
      this.addEventListener('change', this.onChoice);
      this.scope.addEventListener('change', this.onChange);
      document.addEventListener('variant:change', this.onVariant);
      document.addEventListener('visibilitychange', this.onVisibility);
      window.addEventListener('pageshow', this.onPageShow);
      this.pricing = this.scope.querySelector('[data-product-pricing]');
      if (this.pricing) {
        this.observer = new MutationObserver(this.onChange);
        this.observer.observe(this.pricing, {childList: true, subtree: true, characterData: true});
      }
      this.timer = setInterval(() => this.update(), 60000);
      this.reset();
    }
    disconnectedCallback() {
      this.mobileToggle?.removeEventListener('click', this.onMobileToggle);
      this.removeEventListener('change', this.onChoice);
      this.scope?.removeEventListener('change', this.onChange);
      document.removeEventListener('variant:change', this.onVariant);
      document.removeEventListener('visibilitychange', this.onVisibility);
      window.removeEventListener('pageshow', this.onPageShow);
      this.observer?.disconnect();
      clearInterval(this.timer);
      this.initialized = false;
    }
    reset() {
      this.classList.remove('fe-so--expanded');
      this.mobileToggle?.setAttribute('aria-expanded', 'false');
      this.mode = 'standard';
            this.querySelectorAll('input[type="radio"]').forEach(input => input.checked = input.value === 'standard');
      this.update();
    }
    show(selector, visible) {
      const element = this.querySelector(selector);
      if (element) element.hidden = !visible;
    }
    text(selector, text) {
      const element = this.querySelector(selector);
      if (element) element.textContent = text;
    }
    money(cents) {
      return this.formatter.format(Math.round(cents) / 100);
    }
    update(variantId) {
      const id = variantId || this.scope.querySelector('form[action*="/cart/add"] [name="id"]')?.value || this.dataset.variantId;
      const variant = this.variants.find(item => String(item.id) === String(id));
      if (!variant) { this.hidden = true; return; }
      const state = this.constructor.offerState(this.dataset, variant.cents, Date.now() / 1000);
      this.hidden = !state.standard && !state.student && !state.finance && !state.premium;
      if (this.hidden) return;
      if (!state.student && this.mode === 'student') this.mode = 'standard';
      this.querySelectorAll('input[type="radio"]').forEach(input => input.checked = input.value === this.mode);
      const isStudent = this.mode === 'student' && state.student > 0;
      const amount = isStudent ? state.student : state.standard;
      const betterStandard = isStudent && state.standard > state.student;
      this.show('[data-fe-so-cashback]', !!state.standard || !!state.student);
      this.show('[data-fe-so-choice]', !!state.student);
      this.show('[data-fe-so-result]', !!amount);
      this.text('[data-fe-so-label]', isStudent ? this.dataset.labelStudent : this.dataset.labelStandard);
      this.text('[data-fe-so-price]', this.money(Math.max(0, variant.cents - amount)));
      this.text('[data-fe-so-refund-label]', isStudent ? this.dataset.refundStudent : this.dataset.refundStandard);
      this.text('[data-fe-so-amount]', this.money(amount));
      this.text('[data-fe-so-refund-expiry]', ' · ' + (isStudent ? '30/06/2027' : '31/01/2027'));
      this.show('[data-fe-so-hint]', (!amount && !!state.student) || betterStandard);
      this.text('[data-fe-so-hint]', betterStandard ? this.dataset.betterStandard : this.dataset.available);
      this.show('[data-fe-so-cashback-note]', !!amount);
      this.show('[data-fe-so-finance]', state.finance || state.premium);
      this.show('[data-fe-so-normal-finance]', state.finance);
      this.show('[data-fe-so-premium]', state.premium);
      this.show('[data-fe-so-rates]', state.rates);
      this.show('[data-fe-so-below-min]', state.finance && !state.rates);
      [12, 24, 36].forEach(count => this.text('[data-fe-so-rate-' + count + ']', this.money(variant.cents / count)));
      this.show('[data-fe-so-alternative]', isStudent && (state.finance || state.premium));
      this.show('[data-fe-so-normal-terms]', !!state.standard);
      this.show('[data-fe-so-student-terms]', !!state.student);
      this.show('[data-fe-so-finance-terms]', state.finance);
      this.show('[data-fe-so-premium-terms]', state.premium);
      this.show('[data-fe-so-finance-request]', state.finance || state.premium);
      this.scope.querySelectorAll('[data-fe-scb-gift]').forEach(gift => gift.hidden = isStudent);
    }
  });
}
